export default "__VITE_ASSET__bcd2cec8__"